import React, { useEffect, useState } from "react";
import PageLayout from "../components/PageLayout";
import SearchHeader from "../components/SearchHeader";
import ComplaintsDetails from "../components/complaints/ComplaintsDetails";
import { useLoader } from "../context/LoaderContext";
import { useParams } from "react-router-dom";
import { dynamicFailed } from "../hooks/useToast";
import { IComplaint } from "../exports/interfaces";
import { fetchComplaintById } from "../api/ComplaintApi";
import { useUser } from "../context/UserContext";

const ComplaintsDetailsPage = () => {
  const { id } = useParams();
  const { setLoading } = useLoader();

  const [complaint, setComplaint] = useState<IComplaint | null>(null);
  const { user } = useUser();

  useEffect(() => {
    if (!user || !id) {
      return;
    }
    Promise.all([fetchComplaintById(Number(id))])
      .then(([complaintData]) => {
        setComplaint(complaintData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch((error) => {
        dynamicFailed(`${error.message}`);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [id, setLoading, user]);
  return (
    <PageLayout>
      <SearchHeader />
      <div className="inner-main-content">
        <ComplaintsDetails
          complaint={complaint}
        />
      </div>
    </PageLayout>
  );
};

export default ComplaintsDetailsPage;
